import api from '@/lib/api';

export const ajustesAPI = {
  bodegas: () => api.get('/ajustes/bodegas'),
  createBodega: (name) => api.post('/ajustes/bodegas', { name }),
  updateBodega: (id, data) => api.patch(`/ajustes/bodegas/${id}`, data),
  locales: () => api.get('/ajustes/locales'),
  updateLocal: (id, data) => api.patch(`/ajustes/locales/${id}`, data),
  historial: () => api.get('/ajustes/historial'),
};

export const EstadoBadge = ({ active, testId }) => (
  <span className={`text-xs font-semibold px-2 py-0.5 rounded-full ${active ? 'bg-green-100 text-green-700' : 'bg-slate-200 text-slate-600'}`} data-testid={testId}>
    {active ? 'Activa' : 'Inactiva'}
  </span>
);
